import { Howl } from "howler";

const howls = {
  math: new Howl({
    src: ['/sounds/math.mp3']
  }),
  french: new Howl({
    src: ['/sounds/french.mp3']
  }),
  sport: new Howl({
    src: ['/sounds/sport.mp3']
  }),
  gaming: new Howl({
    src: ['/sounds/mario.mp3']
  }),
  sleep: new Howl({
    src: ['/sounds/sleep.mp3']
  }),
  background: new Howl({
    src: ['/sounds/background.mp3'],
    loop: true,
  }),
  winMusic: new Howl({
    src: ['/sounds/win.mp3'],
    loop: true,
  }),
};

export default {
  play: function(howl) {
    if(howls[howl]) {
      const id1 = howls[howl].play();
      howls[howl].fade(1, 0, 1500, id1);
    }
  },
  playBackground: function() {
    howls.background.play();
  },
  stopBackground: function() {
    howls.background.stop();
  },
  playWinMusic: function() {
    howls.winMusic.play();
  },
  stopWinMusic: function() {
    howls.winMusic.stop();
  }
};
